import { render } from "./AddBot.vue?vue&type=template&id=437ba0aa"
import script from "./AddBot.vue?vue&type=script&lang=js"
export * from "./AddBot.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__